/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum UtilitiesJobRequisitionInternalStatus {
  ACTIVE = "ACTIVE",
  NOT_ACTIVE = "NOT_ACTIVE",
}

export enum UtilitiesGlobalSearchTargetType {
  BOARD_FEED = "BOARD_FEED",
  FEED = "FEED",
  SURVEY = "SURVEY",
  GROUP = "GROUP",
  CONTEST = "CONTEST",
  EVENT = "EVENT",
  ONBOARDING = "ONBOARDING",
  REPOSITORY_FILE = "REPOSITORY_FILE",
  REPOSITORY_FOLDER = "REPOSITORY_FOLDER",
  WEBCONTENT = "WEBCONTENT",
}

/** Type of the related resource */
export enum UtilitiesNotificationTargetType {
  GROUP = "GROUP",
  BOARD_FEED = "BOARD_FEED",
  GLOBAL_FEED = "GLOBAL_FEED",
  COMMENT = "COMMENT",
  CONTENT = "CONTENT",
  CONTEST = "CONTEST",
  CHAT = "CHAT",
}

/** Type of the related resource */
export enum UtilitiesNotificationResourceTargetType {
  GROUP = "GROUP",
  BOARD_FEED = "BOARD_FEED",
  GLOBAL_FEED = "GLOBAL_FEED",
  CONTENT = "CONTENT",
  CONTEST = "CONTEST",
  CHAT = "CHAT",
}

export enum UtilitiesNotificationRecipientsType {
  USER = "USER",
  AUDIENCE = "AUDIENCE",
}

export enum UtilitiesNotificationState {
  DRAFT = "DRAFT",
  PUBLISHED = "PUBLISHED",
}

export enum UtilitiesHomepageStatus {
  DRAFT = "DRAFT",
  PUBLISHED = "PUBLISHED",
}

export enum UtilitiesMobileInternalBookmarkRoute {
  MyesseAppHome = "myesse://app/home",
  MyesseAppBoard = "myesse://app/board",
  MyesseAppProfile = "myesse://app/profile",
  MyesseAppContents = "myesse://app/contents",
  MyesseAppGroups = "myesse://app/groups",
  MyesseAppOnboarding = "myesse://app/onboarding",
  MyesseAppEvents = "myesse://app/events",
  MyesseAppContests = "myesse://app/contests",
  MyesseAppRepository = "myesse://app/repository",
  MyesseAppJobPosting = "myesse://app/job-posting",
  MyesseAppKnowledgeBase = "myesse://app/knowledge-base",
  MyesseAppSurveys = "myesse://app/surveys",
  MyesseAppFeedback = "myesse://app/feedback",
  MyesseAppNotifications = "myesse://app/notifications",
  MyesseAppProfileSelfService = "myesse://app/profile/self_service",
  CUSTOM = "CUSTOM",
}

export enum UtilitiesWebappInternalBookmarkRoute {
  ValueHome = "/home",
  ValueBoard = "/board",
  ValueMe = "/me",
  ValueWebcontents = "/webcontents",
  ValueGroups = "/groups",
  ValueOnboarding = "/onboarding",
  ValueEvents = "/events",
  ValueContests = "/contests",
  ValueRepository = "/repository",
  ValueJobPosting = "/job-posting",
  ValueKnowledgeBase = "/knowledge-base",
  ValueSurveys = "/surveys",
  ValueFeedback = "/feedback",
  ValueNotifications = "/notifications",
  ValueMeSelfService = "/me/#self-service",
  CUSTOM = "CUSTOM",
}

/** Target route of the internal bookmark */
export enum UtilitiesInternalBookmarkRoute {
  HOME = "HOME",
  BOARD = "BOARD",
  PROFILE = "PROFILE",
  CONTENTS = "CONTENTS",
  GROUPS = "GROUPS",
  ONBOARDING = "ONBOARDING",
  EVENTS = "EVENTS",
  CONTESTS = "CONTESTS",
  REPOSITORY = "REPOSITORY",
  JOB_POSTING = "JOB_POSTING",
  KNOWLEDGE_BASE = "KNOWLEDGE_BASE",
  SURVEYS = "SURVEYS",
  FEEDBACK = "FEEDBACK",
  NOTIFICATIONS = "NOTIFICATIONS",
  SELF_SERVICE = "SELF_SERVICE",
  CUSTOM = "CUSTOM",
}

/** Type of the bookmark */
export enum UtilitiesBookmarkType {
  INTERNAL = "INTERNAL",
  EXTERNAL = "EXTERNAL",
}

export enum UtilitiesFileType {
  FILE = "FILE",
  FOLDER = "FOLDER",
}

export enum UtilitiesMediaType {
  FILE = "FILE",
  FOLDER = "FOLDER",
}

export interface UtilitiesApplicationFullResponse {
  id: string;
  createdAt: string;
  updatedAt: string;
}

export interface UtilitiesPaginationInfo {
  count: number;
  page: number;
  size: number;
  hasNext?: boolean;
}

export interface UtilitiesCleanApplicationResponse {
  id: string;
  createdAt: string;
  updatedAt: string;
}

export interface UtilitiesPaginatedClearApplicationResponse {
  totalCount?: number;
  paginationInfo: UtilitiesPaginationInfo;
  items: UtilitiesCleanApplicationResponse[];
}

export interface UtilitiesCategoryResponse {
  /**
   * The default name of the category
   * @example "Default Category Name"
   */
  name: string;
  /**
   * A brief description of the category
   * @example "Devices and gadgets related to electronics"
   */
  description: string;
  id: string;
  createdAt: string;
  updatedAt: string;
}

export interface UtilitiesPaginatedCategoryResponse {
  totalCount?: number;
  paginationInfo: UtilitiesPaginationInfo;
  items: UtilitiesCategoryResponse[];
}

export interface UtilitiesCreateCategoryBody {
  /**
   * The name of the category
   * @example "Electronics"
   */
  name: string;
  /**
   * A brief description of the category
   * @example "Devices and gadgets related to electronics"
   */
  description?: string;
}

export interface UtilitiesUpdateCategoryBody {
  /**
   * The name of the category
   * @example "Electronics"
   */
  name: string;
  /**
   * A brief description of the category
   * @example "Devices and gadgets related to electronics"
   */
  description?: string;
}

export type UtilitiesMediaFindByIdResponse = object;

export type UtilitiesMediaListByIdsResponse = object;

export type UtilitiesFunction = object;

export interface UtilitiesMediaResponse {
  name: string;
  type: "FILE" | "FOLDER";
  parent?: UtilitiesFunction;
  id: string;
  url?: string;
  createdAt: string;
  updatedAt: string;
}

export interface UtilitiesPaginatedMediaResponse {
  totalCount?: number;
  paginationInfo: UtilitiesPaginationInfo;
  items: UtilitiesMediaResponse[];
}

export type UtilitiesObjectId = object;

export interface UtilitiesCreateMediaBody {
  /**
   * The name of the media to be created
   * @example "Operation"
   */
  name: string;
  /**
   * The type of the media to be created
   * @example "file"
   */
  type: "FILE" | "FOLDER";
  /**
   * The ID of the parent media, if applicable
   * @example "60c72b2f9b1e8d001c8e4f3a"
   */
  parent?: UtilitiesObjectId;
}

export interface UtilitiesUpdateMediaBody {
  /**
   * The name of the media to be updated
   * @example "New Operation Name"
   */
  name: string;
  /**
   * The ID of the parent media, if applicable
   * @example "60c72b2f9b1e8d001c8e4f3a"
   */
  parent?: UtilitiesObjectId;
}

export type UtilitiesMediaFindByIdServiceConnectPayload = object;

export type UtilitiesMediaFindByIdServiceConnectResponse = object;

export type UtilitiesMediaListByIdsServiceConnectPayload = object;

export type UtilitiesMediaListByIdsServiceConnectResponse = object;

export type UtilitiesFileListFromIdsResponse = object;

export type UtilitiesFileListFromIdsForUserResponse = object;

export type UtilitiesFilterFilesForUserPayload = object;

export interface UtilitiesFileResponse {
  name: string;
  slug?: string;
  type: "FILE" | "FOLDER";
  downloadable: boolean;
  size?: number;
  id: string;
  url?: string;
  parent?: string;
  audiences: string[];
  createdAt: string;
  updatedAt: string;
}

export interface UtilitiesFilterFilesForUserResponse {
  totalCount?: number;
  paginationInfo: UtilitiesPaginationInfo;
  items: UtilitiesFileResponse[];
}

export interface UtilitiesUserFileResponse {
  name: string;
  slug?: string;
  type: "FILE" | "FOLDER";
  downloadable: boolean;
  size?: number;
  id: string;
  url?: string;
  parent?: string;
  createdAt: string;
  updatedAt: string;
}

export interface UtilitiesPaginatedUserFileResponse {
  totalCount?: number;
  paginationInfo: UtilitiesPaginationInfo;
  items: UtilitiesUserFileResponse[];
}

export interface UtilitiesAdminFileResponse {
  name: string;
  slug?: string;
  type: "FILE" | "FOLDER";
  downloadable: boolean;
  size?: number;
  id: string;
  url?: string;
  parent?: string;
  audiences: string[];
  createdAt: string;
  updatedAt: string;
}

export interface UtilitiesPaginatedAdminFileResponse {
  totalCount?: number;
  paginationInfo: UtilitiesPaginationInfo;
  items: UtilitiesAdminFileResponse[];
}

export interface UtilitiesCreateFileBody {
  /**
   * The name of the file to be created
   * @example "Operation"
   */
  name: string;
  /**
   * The optional slug of the file to be created
   * @example "operation"
   */
  slug?: string;
  /**
   * Whether the file is downloadable
   * @example true
   */
  downloadable: boolean;
  /**
   * The type of the file to be created
   * @example "file"
   */
  type: "FILE" | "FOLDER";
  /**
   * The ID of the parent file, if applicable
   * @example "60c72b2f9b1e8d001c8e4f3a"
   */
  parent?: UtilitiesObjectId;
  /**
   * The IDs of the audiences for the file
   * @default []
   * @example ["60c72b2f9b1e8d001c8e4f3b"]
   */
  audiences?: string[];
  /**
   * The size of the file in bytes
   * @example 204800
   */
  size?: number;
}

export interface UtilitiesUpdateFileBody {
  /**
   * The name of the file to be created
   * @example "Operation"
   */
  name?: string;
  /**
   * The optional slug of the file
   * @example "operation"
   */
  slug?: string;
  /**
   * Whether the file is downloadable
   * @example true
   */
  downloadable?: boolean;
  /**
   * The IDs of the audiences for the file
   * @example ["60c72b2f9b1e8d001c8e4f3b"]
   */
  audiences?: string[];
  /**
   * The ID of the parent file, if applicable
   * @example "60c72b2f9b1e8d001c8e4f3a"
   */
  parent?: UtilitiesObjectId;
}

export interface UtilitiesInternalBookmarkBody {
  /** Media id of the bookmark icon */
  icon?: string;
  /** Title of the bookmark */
  title: string;
  /** Type of the bookmark */
  type: UtilitiesBookmarkType;
  /**
   * Array of MongoDB ObjectIds for the target audiences.
   * @default []
   * @example ["60d21b4667d0d8992e610c85","60d21b4967d0d8992e610c88"]
   */
  audiences?: string[];
  /** Target route of the internal bookmark */
  target: UtilitiesInternalBookmarkRoute;
  /** Custom target URL for webapp (overrides the standard internal route) */
  customWebappTarget?: string;
  /** Custom target URL for mobile app (overrides the standard internal route) */
  customMobileTarget?: string;
}

export interface UtilitiesExternalBookmarkBody {
  /** Media id of the bookmark icon */
  icon?: string;
  /** Title of the bookmark */
  title: string;
  /** Type of the bookmark */
  type: UtilitiesBookmarkType;
  /**
   * Array of MongoDB ObjectIds for the target audiences.
   * @default []
   * @example ["60d21b4667d0d8992e610c85","60d21b4967d0d8992e610c88"]
   */
  audiences?: string[];
  /**
   * Target URL of the external bookmark
   * @format uri
   */
  target: string;
  /** Whether to share the auth token when navigating to the external link */
  shareAuthToken: boolean;
}

export interface UtilitiesAudienceFilter {
  field: string;
  values: string[];
  operator:
    | "eq"
    | "ne"
    | "in"
    | "lt"
    | "gt"
    | "le"
    | "ge"
    | "startsWith"
    | "endsWith"
    | "contains"
    | "notContains";
}

export interface UtilitiesAudienceResponse {
  name: string;
  includedFilters: UtilitiesAudienceFilter[];
  excludedFilters: UtilitiesAudienceFilter[];
  id: string;
  description?: string;
  createdAt: string;
  updatedAt: string;
}

export interface UtilitiesExternalBookmarkResponse {
  id: string;
  title: string;
  type: UtilitiesBookmarkType;
  audiences: UtilitiesAudienceResponse[];
  icon?: string;
  target: string;
  shareAuthToken: boolean;
}

export interface UtilitiesInternalBookmarkResponse {
  id: string;
  title: string;
  type: UtilitiesBookmarkType;
  audiences: UtilitiesAudienceResponse[];
  icon?: string;
  mobileTarget: UtilitiesInternalBookmarkRoute;
  webappTarget: UtilitiesWebappInternalBookmarkRoute;
}

export interface UtilitiesExternalBookmarkFullResponse {
  id: string;
  title: string;
  type: UtilitiesBookmarkType;
  audiences: UtilitiesAudienceResponse[];
  icon?: UtilitiesMediaResponse;
  target: string;
  shareAuthToken: boolean;
}

export interface UtilitiesInternalBookmarkFullResponse {
  id: string;
  title: string;
  type: UtilitiesBookmarkType;
  audiences: UtilitiesAudienceResponse[];
  icon?: UtilitiesMediaResponse;
  mobileTarget: UtilitiesMobileInternalBookmarkRoute;
  webappTarget: UtilitiesWebappInternalBookmarkRoute;
}

export interface UtilitiesBannerContentRefResponse {
  id: string;
  slug?: string;
}

export interface UtilitiesBannerItemFullResponse {
  id: string;
  title: string;
  description: string;
  media?: UtilitiesMediaResponse;
  content: UtilitiesBannerContentRefResponse;
}

export interface UtilitiesHomepageFullResponse {
  id: string;
  locale: string;
  status: UtilitiesHomepageStatus;
  banner: UtilitiesBannerItemFullResponse[];
  bookmarks: (
    | UtilitiesInternalBookmarkFullResponse
    | UtilitiesExternalBookmarkFullResponse
  )[];
}

export interface UtilitiesHomepageBackofficeResponse {
  /** Draft version of the homepage */
  draft?: UtilitiesHomepageFullResponse;
  /** Published version of the homepage */
  published?: UtilitiesHomepageFullResponse;
}

export interface UtilitiesBannerItemBody {
  /** Title of the banner item */
  title: string;
  /** Description of the banner item */
  description: string;
  /** Media id of the banner item */
  media: string;
  /** Webcontent id of the banner item */
  content: string;
}

export interface UtilitiesHomepageBody {
  /** Status of the homepage */
  status: UtilitiesHomepageStatus;
  /** Array of banner items */
  banner: UtilitiesBannerItemBody[];
  /** Array of bookmarks (internal or external) */
  bookmarks: (UtilitiesInternalBookmarkBody | UtilitiesExternalBookmarkBody)[];
}

export interface UtilitiesBannerItemResponse {
  id: string;
  title: string;
  description: string;
  media: string;
  content: string;
}

export interface UtilitiesHomepageResponse {
  id: string;
  locale: string;
  status: UtilitiesHomepageStatus;
  banner: UtilitiesBannerItemResponse[];
  bookmarks: (
    | UtilitiesInternalBookmarkResponse
    | UtilitiesExternalBookmarkResponse
  )[];
}

export interface UtilitiesUpdateHomepageBody {
  /** Status of the homepage */
  status: UtilitiesHomepageStatus;
  /** Array of banner items */
  banner: UtilitiesBannerItemBody[];
  /** Array of bookmarks (internal or external) */
  bookmarks: (UtilitiesInternalBookmarkBody | UtilitiesExternalBookmarkBody)[];
  deleteDraft: boolean;
}

export interface UtilitiesNotificationRecipientsValuesResponse {
  /**
   * The name of the recipient
   * @example "Mario Rossi"
   */
  name?: string;
  /**
   * The id of the recipient
   * @example "60c72b2f9b1e8d001c8e4f3a"
   */
  id: string;
}

export interface UtilitiesPopulatedNotificationRecipientsResponse {
  type: UtilitiesNotificationRecipientsType;
  values: UtilitiesNotificationRecipientsValuesResponse[];
}

export interface UtilitiesPopulatedNotificationPayloadResponse {
  text: string;
  media?: UtilitiesMediaResponse;
}

export interface UtilitiesPopulatedAdminNotificationResponse {
  id: string;
  internalTitle: string;
  state: UtilitiesNotificationState;
  scheduledAt?: string;
  relatedResource?:
    | UtilitiesNotificationResourceReferenceResponse
    | UtilitiesNotificationCommentResourceReferenceResponse;
  createdAt: string;
  updatedAt: string;
  recipients: UtilitiesPopulatedNotificationRecipientsResponse;
  payload: UtilitiesPopulatedNotificationPayloadResponse;
}

export interface UtilitiesPaginatedNotificationAdminResponse {
  totalCount?: number;
  paginationInfo: UtilitiesPaginationInfo;
  items: UtilitiesPopulatedAdminNotificationResponse[];
}

export interface UtilitiesNotificationResourceReferenceBody {
  /** ObjectId of the related resource */
  id: string;
  /** Type of the related resource */
  type: UtilitiesNotificationResourceTargetType;
}

export interface UtilitiesNotificationCommentResourceReferenceBody {
  /** ObjectId of the related comment */
  id: string;
  /** Type of the related resource */
  type: UtilitiesNotificationTargetType;
  /** ObjectId of the related feed */
  feedId: string;
}

export interface UtilitiesNotificationRecipientsBody {
  /** Type of recipients for the notification */
  type: UtilitiesNotificationRecipientsType;
  /** List of recipients ObjectIds for the notification */
  values: string[];
}

export interface UtilitiesNotificationPayloadBody {
  /** Notification body text */
  text: string;
  /** Media ObjectId associated with the notification */
  media?: string;
  /** Title associated with the notification */
  title?: string;
}

export interface UtilitiesNotificationBody {
  /** Internal title of the notification */
  internalTitle: string;
  /** Recipients for the notification */
  recipients: UtilitiesNotificationRecipientsBody;
  /** Notification payload body */
  payload: UtilitiesNotificationPayloadBody;
  /** State of the notification */
  state: UtilitiesNotificationState;
  /** Scheduled date and time for the notification */
  scheduledAt?: string;
  /** Related resource reference for the notification */
  relatedResource?:
    | UtilitiesNotificationResourceReferenceBody
    | UtilitiesNotificationCommentResourceReferenceBody;
  /** Flag to skip the notification */
  suppressPushNotification?: boolean;
}

export interface UtilitiesNotificationResourceReferenceResponse {
  id: string;
  type: UtilitiesNotificationResourceTargetType;
  /** Slug of the resource, if available (content slug always available) */
  slug?: string;
}

export interface UtilitiesNotificationCommentResourceReferenceResponse {
  id: string;
  type: UtilitiesNotificationTargetType;
  /** ObjectId of the related feed */
  feedId: string;
}

export interface UtilitiesNotificationRecipientsResponse {
  type: UtilitiesNotificationRecipientsType;
  values: string[];
}

export interface UtilitiesNotificationPayloadResponse {
  text: string;
  media?: string;
}

export interface UtilitiesNotificationAdminResponse {
  id: string;
  internalTitle: string;
  recipients: UtilitiesNotificationRecipientsResponse;
  payload: UtilitiesNotificationPayloadResponse;
  state: UtilitiesNotificationState;
  scheduledAt?: string;
  relatedResource?:
    | UtilitiesNotificationResourceReferenceResponse
    | UtilitiesNotificationCommentResourceReferenceResponse;
  createdAt: string;
  updatedAt: string;
}

export interface UtilitiesNotificationUserResponse {
  id: string;
  payload: UtilitiesPopulatedNotificationPayloadResponse;
  relatedResource?:
    | UtilitiesNotificationResourceReferenceResponse
    | UtilitiesNotificationCommentResourceReferenceResponse;
  appDeepLink?: string;
  hasBeenReadByUser: boolean;
  scheduledAt: string;
  createdAt: string;
  updatedAt: string;
}

export interface UtilitiesPaginatedNotificationUserResponse {
  totalCount?: number;
  paginationInfo: UtilitiesPaginationInfo;
  items: UtilitiesNotificationUserResponse[];
}

export interface UtilitiesMarkNotificationsAsReadBody {
  /** IDs of notifications to mark as read */
  notificationIds: string[];
}

export interface UtilitiesNotificationTokenDto {
  /** Firebase user token */
  token: string;
  /** Firebase DeviceID */
  deviceId: string;
}

export interface UtilitiesNotificationCreateServiceConnectPayload {
  /** Internal title of the notification */
  internalTitle: string;
  /** Recipients for the notification */
  recipients: UtilitiesNotificationRecipientsBody;
  /** Notification payload body */
  payload: UtilitiesNotificationPayloadBody;
  /** State of the notification */
  state: UtilitiesNotificationState;
  /** Scheduled date and time for the notification */
  scheduledAt?: string;
  /** Related resource reference for the notification */
  relatedResource?:
    | UtilitiesNotificationResourceReferenceBody
    | UtilitiesNotificationCommentResourceReferenceBody;
  /** Flag to skip the notification */
  suppressPushNotification?: boolean;
}

export interface UtilitiesSynchronizeNotificationRecipientsServiceConnectPayload {
  relatedResource:
    | UtilitiesNotificationResourceReferenceBody
    | UtilitiesNotificationCommentResourceReferenceBody;
  recipientIds: string[];
}

export interface UtilitiesSynchronizeNotificationRecipientsServiceConnectResponse {
  recipientIds: string[];
}

export interface UtilitiesMyDocumentCategoryWarning {
  id: string;
  description: string;
  /** @default [] */
  audiences: string[];
  /** @format date-time */
  createdAt: string;
}

export interface UtilitiesMyDocumentCategoryNote {
  id: string;
  content: string;
  /** @default [] */
  audiences: string[];
  /** @format date-time */
  createdAt: string;
}

export interface UtilitiesMyDocumentAppCategory {
  id: string;
  code: string;
  title: string;
  docCount: number;
  documentDefinition: string;
  warnings: UtilitiesMyDocumentCategoryWarning[];
  notes: UtilitiesMyDocumentCategoryNote[];
}

export interface UtilitiesMyDocument {
  id: string;
  creationDate: object;
  lastModificationDate: object;
  archiveDate: object;
  title: string;
  note: object;
  openedAt: object;
  documentMonth: string;
  documentYear: string;
  notesOpenedAt: object;
}

export interface UtilitiesMyDocumentDownload {
  downloadToken: string;
}

export interface UtilitiesMyDocumentCategory {
  id: string;
  code: string;
  title: string;
  repoId: string;
  int: number;
  /** @format date-time */
  publishedDate: string;
  year: number;
  cleanYear: number;
  cleanMonth: string;
  documentDefinition: string;
  warnings: UtilitiesMyDocumentCategoryWarning[];
  notes: UtilitiesMyDocumentCategoryNote[];
}

export interface UtilitiesCreateMyDocumentCategoryWarningBody {
  description: string;
  /**
   * @uniqueItems true
   * @default []
   */
  audiences: string[];
}

export interface UtilitiesUpdateMyDocumentCategoryWarningBody {
  description: string;
  /**
   * @uniqueItems true
   * @default []
   */
  audiences: string[];
}

export interface UtilitiesCreateMyDocumentCategoryNoteBody {
  content: string;
  /**
   * @uniqueItems true
   * @default []
   */
  audiences: string[];
}

export interface UtilitiesUpdateMyDocumentCategoryNoteBody {
  content: string;
  /**
   * @uniqueItems true
   * @default []
   */
  audiences: string[];
}

export interface UtilitiesHrDocumentationToken {
  encryptedToken: string;
  /** @format date-time */
  createdAt: string;
  tokenLifetimeSeconds: number;
}

export interface UtilitiesBackofficeChatRecipientResponse {
  /**
   * The type of recipient - either user or audiences
   * @example "USERS"
   */
  type: "USERS" | "AUDIENCES";
  /**
   * The name of the recipient
   * @example "Mario Rossi"
   */
  name: string;
  /**
   * The id of the recipient
   * @example "60c72b2f9b1e8d001c8e4f3a"
   */
  id: string;
}

export interface UtilitiesBackofficeChatResponse {
  /**
   * The unique identifier of the chat
   * @example "60c72b2f9b1e8d001c8e4f3a"
   */
  id: string;
  /**
   * The title of the chat
   * @example "Team Discussion"
   */
  title: string;
  /**
   * The internal title of the chat
   * @example "team-discussion-2024"
   */
  internalTitle: string;
  /**
   * The label of the admin sender (e.g. "Admin", "System", "System Message")
   * @example "Admin"
   */
  adminSenderLabel: string;
  /**
   * The status of the chat
   * @example "DRAFT"
   */
  status: "PUBLISHED" | "DRAFT" | "BLOCKED";
  /**
   * The recipients of the chat
   * @example [{"type":"USERS","name":"Mario Rossi","id":"60c72b2f9b1e8d001c8e4f3a"},{"type":"AUDIENCES","name":"Atlantic","id":"60c72b2f9b1e8d001c8e4f3b"}]
   */
  recipients: UtilitiesBackofficeChatRecipientResponse[];
  /**
   * The number of messages in the chat
   * @example 10
   */
  numberOfMessages: number;
}

export interface UtilitiesBackofficeChatListResponse {
  totalCount?: number;
  paginationInfo: UtilitiesPaginationInfo;
  items: UtilitiesBackofficeChatResponse[];
}

export interface UtilitiesChatRecipientsDto {
  /**
   * The type of recipients - either users or audiences
   * @example "USERS"
   */
  type: "USERS" | "AUDIENCES";
  /**
   * Array of user IDs or audience IDs (must match the type)
   * @minItems 1
   * @example ["60c72b2f9b1e8d001c8e4f3a","60c72b2f9b1e8d001c8e4f3b"]
   */
  values: string[];
}

export interface UtilitiesMessageAttachmentDto {
  /**
   * The filename of the attachment
   * @example "document.pdf"
   */
  fileName?: string;
  /**
   * The S3 key of the attachment
   * @example "chat-attachments/60c72b2f9b1e8d001c8e4f3a/document.pdf"
   */
  key: string;
}

export interface UtilitiesCreateFirstMessageBody {
  /**
   * The text content of the message
   * @example "Hello everyone! This is the first message in the chat."
   */
  text: string;
  /** Optional attachments for the message */
  attachments?: UtilitiesMessageAttachmentDto[];
}

export interface UtilitiesCreateChatBody {
  /**
   * The title of the chat
   * @example "Team Discussion"
   */
  title: string;
  /**
   * The internal title of the chat
   * @example "team-discussion-2024"
   */
  internalTitle: string;
  /**
   * The label of the admin sender (e.g. "Admin", "System", "System Message")
   * @example "Admin"
   */
  adminSenderLabel: string;
  /** The recipients of the chat */
  recipients: UtilitiesChatRecipientsDto;
  /** The first message of the chat that will be sent to all recipients (users or audiences) */
  firstMessage: UtilitiesCreateFirstMessageBody;
  /**
   * Whether to send a push notification to the recipients, default is false
   * @default false
   * @example true
   */
  createPushNotification?: boolean;
}

export interface UtilitiesCreateChatResponse {
  /**
   * The unique identifier of the chat
   * @example "60c72b2f9b1e8d001c8e4f3a"
   */
  id: string;
  /**
   * The title of the chat
   * @example "Team Discussion"
   */
  title: string;
  /**
   * The internal title of the chat
   * @example "team-discussion-2024"
   */
  internalTitle: string;
  /**
   * The label of the admin sender (e.g. "Admin", "System", "System Message")
   * @example "Admin"
   */
  adminSenderLabel: string;
  /**
   * The status of the chat
   * @example "DRAFT"
   */
  status: "PUBLISHED" | "DRAFT" | "BLOCKED";
  /**
   * The date and time when the chat was created
   * @example "2025-08-22T10:15:30.000Z"
   */
  createdAt: string;
  /**
   * The date and time when the chat was last updated
   * @example "2025-08-22T10:15:30.000Z"
   */
  updatedAt: string;
}

export interface UtilitiesPresignedStorageResource {
  /** The unique key to identify the file in the S3 bucket */
  key: string;
  /** The pre-signed URL to upload or access the file in S3 */
  presignedUrl: string;
}

export interface UtilitiesMessageAttachmentResponse {
  /**
   * The filename of the attachment
   * @example "document.pdf"
   */
  fileName?: string;
  /**
   * The S3 key of the attachment
   * @example "chat-attachments/60c72b2f9b1e8d001c8e4f3a/document.pdf"
   */
  key: string;
  /**
   * The presigned URL to access the attachment
   * @example "https://s3.amazonaws.com/your-bucket/chat-attachments/60c72b2f9b1e8d001c8e4f3a/document.pdf?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=..."
   */
  presignedUrl: string;
}

export interface UtilitiesFirstMessageResponse {
  /**
   * The text content of the first message
   * @example "Hello everyone! This is the first message in the chat."
   */
  text: string;
  /**
   * Optional attachment for the first message
   * @example [{"key":"chat-attachments/60c72b2f9b1e8d001c8e4f3a/document.pdf","fileName":"document.pdf"}]
   */
  attachments?: UtilitiesMessageAttachmentResponse[];
}

export interface UtilitiesChatRecipientsResponse {
  /**
   * The type of recipients - either user or audiences
   * @example "USERS"
   */
  type: "USERS" | "AUDIENCES";
  /**
   * The ids of the recipients
   * @example ["60c72b2f9b1e8d001c8e4f3a","60c72b2f9b1e8d001c8e4f3b"]
   */
  values: string[];
}

export interface UtilitiesBackofficeChatUserRecipientResponse {
  /**
   * The id of the recipient
   * @example "60c72b2f9b1e8d001c8e4f3a"
   */
  userId: string;
  /**
   * The full name of the recipient (first name and last name)
   * @example "Mario Rossi"
   */
  fullName: string;
  /**
   * The number of messages for this recipient
   * @example 5
   */
  numberOfMessages: number;
  /**
   * The date and time of the last message for this recipient
   * @example "2025-08-22T10:15:30.000Z"
   */
  lastMessageDateTime: string;
}

export interface UtilitiesBackofficeChatDetailResponse {
  /**
   * The unique identifier of the chat
   * @example "60c72b2f9b1e8d001c8e4f3a"
   */
  id: string;
  /**
   * The title of the chat
   * @example "Team Discussion"
   */
  title: string;
  /**
   * The internal title of the chat
   * @example "team-discussion-2024"
   */
  internalTitle: string;
  /** The first message of the chat */
  firstMessage: UtilitiesFirstMessageResponse;
  /**
   * The label of the admin sender (e.g. "Admin", "System", "System Message")
   * @example "Admin"
   */
  adminSenderLabel: string;
  /**
   * The status of the chat
   * @example "PUBLISHED"
   */
  status: "PUBLISHED" | "DRAFT" | "BLOCKED";
  /**
   * Whether the chat can be updated
   * @example true
   */
  editable: boolean;
  /** The recipients of the chat, to be used when sending messages as "reply to all" */
  chatRecipients: UtilitiesChatRecipientsResponse;
  /**
   * The recipients of the chat to be displayed in the "to" section
   * @example [{"type":"USERS","name":"Mario Rossi","id":"60c72b2f9b1e8d001c8e4f3a"},{"type":"AUDIENCES","name":"Atlantic","id":"60c72b2f9b1e8d001c8e4f3b"}]
   */
  targets: UtilitiesBackofficeChatRecipientResponse[];
  /**
   * The expanded list of chat users with their details, will not be returned if the chat status is DRAFT
   * @example [{"userId":"60c72b2f9b1e8d001c8e4f3a","fullName":"Mario Rossi","numberOfMessages":5,"lastMessageDateTime":"2025-08-22T10:15:30.000Z"}]
   */
  userRecipientsList?: UtilitiesBackofficeChatUserRecipientResponse[];
}

export interface UtilitiesUpdateDraftChatBody {
  /**
   * The title of the chat
   * @example "Team Discussion"
   */
  title: string;
  /**
   * The internal title of the chat
   * @example "team-discussion-2024"
   */
  internalTitle: string;
  /**
   * The label of the admin sender (e.g. "Admin", "System", "System Message")
   * @example "Admin"
   */
  adminSenderLabel: string;
  /** The recipients of the chat */
  recipients: UtilitiesChatRecipientsDto;
  /** The first message of the chat that will be sent to all recipients (users or audiences) */
  firstMessage: UtilitiesCreateFirstMessageBody;
  /**
   * Whether to send a push notification to the recipients, default is false
   * @default false
   * @example true
   */
  createPushNotification?: boolean;
}

export interface UtilitiesUpdateDraftChatResponse {
  /**
   * The unique identifier of the chat
   * @example "60c72b2f9b1e8d001c8e4f3a"
   */
  id: string;
  /**
   * The title of the chat
   * @example "Team Discussion"
   */
  title: string;
  /**
   * The internal title of the chat
   * @example "team-discussion-2024"
   */
  internalTitle: string;
  /**
   * The label of the admin sender (e.g. "Admin", "System", "System Message")
   * @example "Admin"
   */
  adminSenderLabel: string;
  /**
   * The status of the chat
   * @example "DRAFT"
   */
  status: "PUBLISHED" | "DRAFT" | "BLOCKED";
  /**
   * The date and time when the chat was created
   * @example "2025-08-22T10:15:30.000Z"
   */
  createdAt: string;
  /**
   * The date and time when the chat was last updated
   * @example "2025-08-22T10:15:30.000Z"
   */
  updatedAt: string;
}

export interface UtilitiesMessageRecipientsDto {
  /**
   * The type of recipients - either users or audiences
   * @example "AUDIENCES"
   */
  type: "USERS" | "AUDIENCES";
  /**
   * Array of user IDs or audience IDs
   * @minItems 1
   * @example ["60c72b2f9b1e8d001c8e4f3a"]
   */
  values: string[];
}

export interface UtilitiesSendMessageToBackofficeChatBody {
  /**
   * The text content of the message
   * @example "Hello everyone! This is the first message in the chat."
   */
  text: string;
  /** Optional attachments for the message */
  attachments?: UtilitiesMessageAttachmentDto[];
  /** The recipients of the message. Must be within the chat recipients */
  recipients: UtilitiesMessageRecipientsDto;
}

export interface UtilitiesSendMessageToBackofficeChatResponse {
  /**
   * The unique identifier of the message
   * @example "60c72b2f9b1e8d001c8e4f3a"
   */
  id: string;
  /**
   * The date and time when the message was created
   * @example "2025-08-22T10:15:30.000Z"
   */
  createdAt: string;
}

export interface UtilitiesChatDetailMessageResponse {
  /**
   * The unique identifier of the message
   * @example "60c72b2f9b1e8d001c8e4f3a"
   */
  id: string;
  /**
   * Whether the message was sent by the admin, to be displayed as an admin message
   * @example true
   */
  isAdminMessage: boolean;
  /**
   * The name of the message sender
   * @example "Mario Rossi"
   */
  senderLabel: string;
  /**
   * The text content of the message
   * @example "Hello everyone! This is a message."
   */
  text: string;
  /**
   * Optional attachments for the message
   * @example [{"key":"chat-attachments/60c72b2f9b1e8d001c8e4f3a/document.pdf","fileName":"document.pdf"}]
   */
  attachments?: UtilitiesMessageAttachmentResponse[];
  /**
   * The date and time when the message was sent
   * @example "2025-08-22T10:15:30.000Z"
   */
  createdAt: string;
}

export interface UtilitiesBackofficeChatDetailMessageListResponse {
  totalCount?: number;
  paginationInfo: UtilitiesPaginationInfo;
  items: UtilitiesChatDetailMessageResponse[];
}

export interface UtilitiesSendMessageToHrManagerBody {
  /**
   * The subject of the message sent to the HR manager
   * @example "Richiesta colloquio"
   */
  subject: string;
  /**
   * The text content of the message sent to the HR manager
   * @example "Buongiorno, vorrei prenotare un colloquio per discutere della mia posizione."
   */
  message: string;
}

export interface UtilitiesSendMessageToChatResponse {
  /**
   * The unique identifier of the message
   * @example "60c72b2f9b1e8d001c8e4f3a"
   */
  id: string;
  /**
   * The date and time when the message was created
   * @example "2025-08-22T10:15:30.000Z"
   */
  createdAt: string;
}

export interface UtilitiesChatListItemResponse {
  /**
   * The unique identifier of the chat
   * @example "60c72b2f9b1e8d001c8e4f3a"
   */
  id: string;
  /**
   * The label of the sender (e.g. "Mario Rossi", "Group Name")
   * @example "Mario Rossi"
   */
  senderLabel: string;
  /**
   * The title of the chat
   * @example "Team Discussion"
   */
  title: string;
  /**
   * The text of the last message
   * @example "Hello! How are you?"
   */
  lastMessageText: string;
  /**
   * The date and time of the last message
   * @example "2025-08-22T10:15:30.000Z"
   */
  lastMessageDateTime: string;
  /**
   * Whether the chat has been read by the authenticated user
   * @example false
   */
  read: boolean;
  /**
   * The status of the chat, either published or blocked
   * @example "PUBLISHED"
   */
  status: "PUBLISHED" | "DRAFT" | "BLOCKED";
}

export interface UtilitiesChatListResponse {
  totalCount?: number;
  paginationInfo: UtilitiesPaginationInfo;
  items: UtilitiesChatListItemResponse[];
}

export interface UtilitiesChatDetailResponse {
  /**
   * The unique identifier of the chat
   * @example "60c72b2f9b1e8d001c8e4f3a"
   */
  id: string;
  /**
   * The label of the sender (e.g. "Mario Rossi", "Group Name")
   * @example "Mario Rossi"
   */
  senderLabel: string;
  /**
   * The title of the chat
   * @example "Team Discussion"
   */
  title: string;
  /**
   * The status of the chat, either published or blocked
   * @example "PUBLISHED"
   */
  status: "PUBLISHED" | "DRAFT" | "BLOCKED";
}

export interface UtilitiesChatReadStatusResponse {
  /**
   * The unique identifier of the chat
   * @example "60c72b2f9b1e8d001c8e4f3a"
   */
  id: string;
  /**
   * The date and time of the last read action by the authenticated user
   * @example "2025-08-22T10:15:30.000Z"
   */
  lastReadDateTime: string;
}

export interface UtilitiesSendMessageToChatBody {
  /**
   * The text content of the message
   * @example "Hello everyone! This is the first message in the chat."
   */
  text: string;
  /** Optional attachments for the message */
  attachments?: UtilitiesMessageAttachmentDto[];
}

export interface UtilitiesChatDetailMessageListResponse {
  totalCount?: number;
  paginationInfo: UtilitiesPaginationInfo;
  items: UtilitiesChatDetailMessageResponse[];
}

export interface UtilitiesAppVersion {
  /**
   * The minimum iOS version required
   * @example "1.0.0"
   */
  ios: string;
  /**
   * The minimum Android version required
   * @example "1.0.0"
   */
  android: string;
}

export interface UtilitiesAppConfigResponse {
  /** The mandatory version information for the app */
  mandatoryVersion: UtilitiesAppVersion;
  /** Indicates whether the user is hired */
  isUserHired: boolean;
  /**
   * The feature flags for the app
   * @example {"featureA":true,"featureB":false}
   */
  featureFlags: Record<string, boolean>;
  id: string;
  createdAt: string;
  updatedAt: string;
}

export interface UtilitiesGlobalSearchRecordResponse {
  id: string;
  /** The target identifier (id or slug) of the resource */
  targetId: string;
  title: string;
  description?: string;
  cover?: UtilitiesMediaResponse;
  type: UtilitiesGlobalSearchTargetType;
  mobileAppUri: string;
  webAppUri: string;
}

export interface UtilitiesPaginatedGlobalSearchResponse {
  totalCount?: number;
  paginationInfo: UtilitiesPaginationInfo;
  items: UtilitiesGlobalSearchRecordResponse[];
}

export interface UtilitiesAdminJobPostResponse {
  id: string;
  jobReqId: string;
  jobTitle: string;
  jobDescription: string;
  externalTitle?: object;
  externalJobDescription?: object;
  status?: UtilitiesJobRequisitionInternalStatus | null;
  audiences: string[];
  cover?: UtilitiesMediaResponse;
  createdAt: string;
  updatedAt: string;
}

export interface UtilitiesPaginatedAdminJobPostResponse {
  totalCount?: number;
  paginationInfo: UtilitiesPaginationInfo;
  items: UtilitiesAdminJobPostResponse[];
}

export interface UtilitiesUpdateAdminJobPostBody {
  /**
   * Array of MongoDB ObjectIds for the target audiences.
   * @default []
   * @example ["60d21b4667d0d8992e610c85","60d21b4967d0d8992e610c88"]
   */
  audiences?: string[];
  /**
   * Media library image id for the instant feedback, if any.
   * @example "60d21b4667d0d8992e610c85"
   */
  cover?: string;
}

export interface UtilitiesJobPostResponse {
  id: string;
  jobReqId: string;
  jobTitle: string;
  jobDescription: string;
  link: string;
  cover?: UtilitiesMediaResponse;
  createdAt: string;
  updatedAt: string;
}

export interface UtilitiesPaginatedJobPostResponse {
  totalCount?: number;
  paginationInfo: UtilitiesPaginationInfo;
  items: UtilitiesJobPostResponse[];
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Utilities API
 * @version 1.0.0
 * @contact
 *
 * Comprehensive API documentation for managing utilities and their related operations
 */
export class UtilitiesApi<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  utilities = {
    /**
     * No description
     *
     * @tags Healthcheck
     * @name HealthcheckControllerCheck
     * @request GET:/utilities/healthcheck
     */
    healthcheckControllerCheck: (params: RequestParams = {}) =>
      this.request<
        {
          /** @example "ok" */
          status?: string;
          /** @example {"database":{"status":"up"}} */
          info?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
          /** @example {} */
          error?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
          /** @example {"database":{"status":"up"}} */
          details?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
        },
        {
          /** @example "error" */
          status?: string;
          /** @example {"database":{"status":"up"}} */
          info?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
          /** @example {"redis":{"status":"down","message":"Could not connect"}} */
          error?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
          /** @example {"database":{"status":"up"},"redis":{"status":"down","message":"Could not connect"}} */
          details?: Record<
            string,
            {
              status: string;
              [key: string]: any;
            }
          >;
        }
      >({
        path: `/utilities/healthcheck`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Returns the application information for the given ID.
     *
     * @tags Applications
     * @name ApplicationControllerFindById
     * @summary Get application by ID
     * @request GET:/utilities/applications/{id}
     */
    applicationControllerFindById: (id: string, params: RequestParams = {}) =>
      this.request<UtilitiesApplicationFullResponse, void>({
        path: `/utilities/applications/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a paginated list of applications with optional count.
     *
     * @tags Applications
     * @name ApplicationControllerFindAll
     * @summary List of all applications
     * @request GET:/utilities/applications
     */
    applicationControllerFindAll: (
      query?: {
        /**
         * Page number (default is 1)
         * @min 1
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Page size (default is 10)
         * @min 1
         * @default 10
         * @example 10
         */
        size?: number;
        /**
         * Whether to get the total count
         * @default false
         * @example false
         */
        getTotalCount?: boolean;
        /**
         * Field to sort by
         * @example "name"
         */
        sortBy?: string;
        /**
         * Order of sorting (asc or desc)
         * @example "asc"
         */
        orderBy?: "asc" | "desc";
        /**
         * Filter applications by name or type. Partial and case-insensitive matching is supported.
         * @example "Excavator"
         */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesPaginatedClearApplicationResponse, any>({
        path: `/utilities/applications`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns the category information for the given ID.
     *
     * @tags Categories
     * @name CategoryControllerFindById
     * @summary Get category by ID
     * @request GET:/utilities/categories/{id}
     */
    categoryControllerFindById: (id: string, params: RequestParams = {}) =>
      this.request<UtilitiesCategoryResponse, void>({
        path: `/utilities/categories/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Updates the category information for the given ID and returns the updated category.
     *
     * @tags Categories
     * @name CategoryControllerUpdate
     * @summary Update an existing category
     * @request PUT:/utilities/categories/{id}
     */
    categoryControllerUpdate: (
      id: string,
      data: UtilitiesUpdateCategoryBody,
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesCategoryResponse, any>({
        path: `/utilities/categories/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Deletes the category for the given ID.
     *
     * @tags Categories
     * @name CategoryControllerDelete
     * @summary Delete a category
     * @request DELETE:/utilities/categories/{id}
     */
    categoryControllerDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/utilities/categories/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Returns a paginated list of categories with optional count.
     *
     * @tags Categories
     * @name CategoryControllerFindAll
     * @summary List of all categories
     * @request GET:/utilities/categories
     */
    categoryControllerFindAll: (
      query?: {
        /**
         * Page number (default is 1)
         * @min 1
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Page size (default is 10)
         * @min 1
         * @default 10
         * @example 10
         */
        size?: number;
        /**
         * Whether to get the total count
         * @default false
         * @example false
         */
        getTotalCount?: boolean;
        /**
         * Field to sort by
         * @example "name"
         */
        sortBy?: string;
        /**
         * Order of sorting (asc or desc)
         * @example "asc"
         */
        orderBy?: "asc" | "desc";
        /**
         * Filter categories by name or type. Partial and case-insensitive matching is supported.
         * @example "Excavator"
         */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesPaginatedCategoryResponse, any>({
        path: `/utilities/categories`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a new category and returns its information.
     *
     * @tags Categories
     * @name CategoryControllerCreate
     * @summary Create a new category
     * @request POST:/utilities/categories
     */
    categoryControllerCreate: (
      data: UtilitiesCreateCategoryBody,
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesCategoryResponse, any>({
        path: `/utilities/categories`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a paginated list of media with optional count.
     *
     * @tags Media Libraries
     * @name MediaLibraryControllerFindAll
     * @summary List of all media
     * @request GET:/utilities/media-library
     */
    mediaLibraryControllerFindAll: (
      query?: {
        /**
         * Page number (default is 1)
         * @min 1
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Page size (default is 10)
         * @min 1
         * @default 10
         * @example 10
         */
        size?: number;
        /**
         * Whether to get the total count
         * @default false
         * @example false
         */
        getTotalCount?: boolean;
        /**
         * Field to sort by
         * @example "name"
         */
        sortBy?: string;
        /**
         * Order of sorting (asc or desc)
         * @example "asc"
         */
        orderBy?: "asc" | "desc";
        /**
         * Filter media by name. Partial and case-insensitive matching is supported.
         * @example "image1"
         */
        search?: string;
        /**
         * Filter media by parent folder ObjectId.
         * @example "60c72b2f9b1e8e6d88f0e7c2"
         */
        parent?: string;
        /** Filter files by type (e.g., "folder", "file"). */
        type?: UtilitiesMediaType;
      },
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesPaginatedMediaResponse, any>({
        path: `/utilities/media-library`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a new media entry in the media library.
     *
     * @tags Media Libraries
     * @name MediaLibraryControllerCreate
     * @summary Create new media
     * @request POST:/utilities/media-library
     */
    mediaLibraryControllerCreate: (
      data: UtilitiesCreateMediaBody,
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesMediaResponse, any>({
        path: `/utilities/media-library`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns the media with the specified ID.
     *
     * @tags Media Libraries
     * @name MediaLibraryControllerFindById
     * @summary Get media by ID
     * @request GET:/utilities/media-library/{id}
     */
    mediaLibraryControllerFindById: (id: string, params: RequestParams = {}) =>
      this.request<UtilitiesMediaResponse, any>({
        path: `/utilities/media-library/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Updates the media with the specified ID in the media library.
     *
     * @tags Media Libraries
     * @name MediaLibraryControllerUpdate
     * @summary Update media by ID
     * @request PUT:/utilities/media-library/{id}
     */
    mediaLibraryControllerUpdate: (
      id: string,
      data: UtilitiesUpdateMediaBody,
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesMediaResponse, void>({
        path: `/utilities/media-library/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Deletes the media with the specified ID from the media library.
     *
     * @tags Media Libraries
     * @name MediaLibraryControllerDelete
     * @summary Delete media by ID
     * @request DELETE:/utilities/media-library/{id}
     */
    mediaLibraryControllerDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/utilities/media-library/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Stream the media to the client
     *
     * @tags Media Libraries
     * @name MediaLibraryControllerDownload
     * @summary Download media by ID
     * @request GET:/utilities/media-library/{id}/download
     */
    mediaLibraryControllerDownload: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/utilities/media-library/${id}/download`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MediaLibraryServiceConnect
     * @name MediaLibraryServiceConnectControllerHandleFindById
     * @request POST:/utilities/internal/media-library/find-by-id
     */
    mediaLibraryServiceConnectControllerHandleFindById: (
      data: UtilitiesMediaFindByIdServiceConnectPayload,
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesMediaFindByIdServiceConnectResponse, any>({
        path: `/utilities/internal/media-library/find-by-id`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MediaLibraryServiceConnect
     * @name MediaLibraryServiceConnectControllerHandleListByIds
     * @request POST:/utilities/internal/media-library/list-by-ids
     */
    mediaLibraryServiceConnectControllerHandleListByIds: (
      data: UtilitiesMediaListByIdsServiceConnectPayload,
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesMediaListByIdsServiceConnectResponse, any>({
        path: `/utilities/internal/media-library/list-by-ids`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a paginated list of files with optional count.
     *
     * @tags Repository
     * @name RepositoryControllerFindAll
     * @summary List of all files
     * @request GET:/utilities/repository
     */
    repositoryControllerFindAll: (
      query?: {
        /**
         * Page number (default is 1)
         * @min 1
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Page size (default is 10)
         * @min 1
         * @default 10
         * @example 10
         */
        size?: number;
        /**
         * Whether to get the total count
         * @default false
         * @example false
         */
        getTotalCount?: boolean;
        /**
         * Field to sort by
         * @example "name"
         */
        sortBy?: string;
        /**
         * Order of sorting (asc or desc)
         * @example "asc"
         */
        orderBy?: "asc" | "desc";
        /**
         * Filter files by name. Partial and case-insensitive matching is supported.
         * @example "image1"
         */
        search?: string;
        /**
         * Filter files by parent folder ObjectId or slug.
         * @example "60c72b2f9b1e8e6d88f0e7c2"
         */
        parent?: string;
        /** Filter files by type (e.g., "folder", "file"). */
        type?: UtilitiesFileType;
      },
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesPaginatedUserFileResponse, any>({
        path: `/utilities/repository`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns the file with the specified ID or slug.
     *
     * @tags Repository
     * @name RepositoryControllerFindById
     * @summary Get file by ID or slug
     * @request GET:/utilities/repository/{id}
     */
    repositoryControllerFindById: (id: string, params: RequestParams = {}) =>
      this.request<UtilitiesUserFileResponse, any>({
        path: `/utilities/repository/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a paginated list of files with optional count.
     *
     * @tags Backoffice-Repository
     * @name RepositoryBackofficeControllerFindAll
     * @summary List of all files
     * @request GET:/utilities/backoffice/repository
     */
    repositoryBackofficeControllerFindAll: (
      query?: {
        /**
         * Page number (default is 1)
         * @min 1
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Page size (default is 10)
         * @min 1
         * @default 10
         * @example 10
         */
        size?: number;
        /**
         * Whether to get the total count
         * @default false
         * @example false
         */
        getTotalCount?: boolean;
        /**
         * Field to sort by
         * @example "name"
         */
        sortBy?: string;
        /**
         * Order of sorting (asc or desc)
         * @example "asc"
         */
        orderBy?: "asc" | "desc";
        /**
         * Filter files by name. Partial and case-insensitive matching is supported.
         * @example "image1"
         */
        search?: string;
        /**
         * Filter files by parent folder ObjectId or slug.
         * @example "60c72b2f9b1e8e6d88f0e7c2"
         */
        parent?: string;
        /** Filter files by type (e.g., "folder", "file"). */
        type?: UtilitiesFileType;
      },
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesPaginatedAdminFileResponse, any>({
        path: `/utilities/backoffice/repository`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a new file entry in the repository.
     *
     * @tags Backoffice-Repository
     * @name RepositoryBackofficeControllerCreate
     * @summary Create new file
     * @request POST:/utilities/backoffice/repository
     */
    repositoryBackofficeControllerCreate: (
      data: UtilitiesCreateFileBody,
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesAdminFileResponse, any>({
        path: `/utilities/backoffice/repository`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns the file with the specified ID or slug.
     *
     * @tags Backoffice-Repository
     * @name RepositoryBackofficeControllerFindById
     * @summary Get file by ID or slug
     * @request GET:/utilities/backoffice/repository/{id}
     */
    repositoryBackofficeControllerFindById: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesAdminFileResponse, any>({
        path: `/utilities/backoffice/repository/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Updates the file with the specified ID.
     *
     * @tags Backoffice-Repository
     * @name RepositoryBackofficeControllerUpdate
     * @summary Update file by ID
     * @request PUT:/utilities/backoffice/repository/{id}
     */
    repositoryBackofficeControllerUpdate: (
      id: string,
      data: UtilitiesUpdateFileBody,
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesAdminFileResponse, any>({
        path: `/utilities/backoffice/repository/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Deletes the file with the specified ID from the file library.
     *
     * @tags Backoffice-Repository
     * @name RepositoryBackofficeControllerDelete
     * @summary Delete file by ID
     * @request DELETE:/utilities/backoffice/repository/{id}
     */
    repositoryBackofficeControllerDelete: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/utilities/backoffice/repository/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Home
     * @name HomepageControllerGetHomepage
     * @request GET:/utilities/home
     */
    homepageControllerGetHomepage: (params: RequestParams = {}) =>
      this.request<UtilitiesHomepageBackofficeResponse, any>({
        path: `/utilities/home`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Home
     * @name HomepageControllerCreateHomepage
     * @request POST:/utilities/home
     */
    homepageControllerCreateHomepage: (
      data: UtilitiesHomepageBody,
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesHomepageResponse, any>({
        path: `/utilities/home`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Home
     * @name HomepageControllerUpdateHomepage
     * @request PUT:/utilities/home
     */
    homepageControllerUpdateHomepage: (
      data: UtilitiesUpdateHomepageBody,
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesHomepageResponse, any>({
        path: `/utilities/home`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Home
     * @name HomepageControllerGetBookmarks
     * @request GET:/utilities/home/bookmarks
     */
    homepageControllerGetBookmarks: (params: RequestParams = {}) =>
      this.request<object[], any>({
        path: `/utilities/home/bookmarks`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Home
     * @name HomepageControllerGetBanner
     * @request GET:/utilities/home/banner
     */
    homepageControllerGetBanner: (params: RequestParams = {}) =>
      this.request<UtilitiesBannerItemFullResponse[], any>({
        path: `/utilities/home/banner`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description List all notifications,
     *
     * @tags Notification
     * @name NotificationControllerFindAll
     * @summary List all notifications
     * @request GET:/utilities/notifications
     */
    notificationControllerFindAll: (
      query?: {
        /**
         * Page number (default is 1)
         * @min 1
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Page size (default is 10)
         * @min 1
         * @default 10
         * @example 10
         */
        size?: number;
        /**
         * Whether to get the total count
         * @default false
         * @example false
         */
        getTotalCount?: boolean;
        /**
         * Field to sort by
         * @example "name"
         */
        sortBy?: string;
        /**
         * Order of sorting (asc or desc)
         * @example "asc"
         */
        orderBy?: "asc" | "desc";
        /** Filter notifications by internal title. Partial and case-insensitive matching is supported. */
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesPaginatedNotificationAdminResponse, any>({
        path: `/utilities/notifications`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new notification
     *
     * @tags Notification
     * @name NotificationControllerCreateNotification
     * @summary Create notification
     * @request POST:/utilities/notifications
     */
    notificationControllerCreateNotification: (
      data: UtilitiesNotificationBody,
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesNotificationAdminResponse, any>({
        path: `/utilities/notifications`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve a notification by its ID
     *
     * @tags Notification
     * @name NotificationControllerFindOne
     * @summary Get notification by ID
     * @request GET:/utilities/notifications/{id}
     */
    notificationControllerFindOne: (id: string, params: RequestParams = {}) =>
      this.request<UtilitiesPopulatedAdminNotificationResponse, any>({
        path: `/utilities/notifications/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Updates the notification with the given id
     *
     * @tags Notification
     * @name NotificationControllerUpdateNotification
     * @summary Update notification
     * @request PUT:/utilities/notifications/{id}
     */
    notificationControllerUpdateNotification: (
      id: string,
      data: UtilitiesNotificationBody,
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesNotificationAdminResponse, any>({
        path: `/utilities/notifications/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Deletes the notification with the given id
     *
     * @tags Notification
     * @name NotificationControllerDeleteNotification
     * @summary Delete notification
     * @request DELETE:/utilities/notifications/{id}
     */
    notificationControllerDeleteNotification: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/utilities/notifications/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description List all notifications for a specific user
     *
     * @tags Notification
     * @name AppNotificationControllerFindAll
     * @summary List all notifications for a specific user
     * @request GET:/utilities/app/notifications
     */
    appNotificationControllerFindAll: (
      query?: {
        /**
         * Page number (default is 1)
         * @min 1
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Page size (default is 10)
         * @min 1
         * @default 10
         * @example 10
         */
        size?: number;
        /**
         * Whether to get the total count
         * @default false
         * @example false
         */
        getTotalCount?: boolean;
        /** Filter notifications by unread status. If not provided, both read and unread notifications are returned. If true, only unread notifications are returned. */
        unread?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesPaginatedNotificationUserResponse, any>({
        path: `/utilities/app/notifications`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notification
     * @name AppNotificationControllerBulkMarkAsRead
     * @request POST:/utilities/app/notifications/reads
     */
    appNotificationControllerBulkMarkAsRead: (
      data: UtilitiesMarkNotificationsAsReadBody,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/utilities/app/notifications/reads`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notification
     * @name AppNotificationControllerMarkAsRead
     * @request POST:/utilities/app/notifications/{id}/reads
     */
    appNotificationControllerMarkAsRead: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/utilities/app/notifications/${id}/reads`,
        method: "POST",
        ...params,
      }),

    /**
     * @description Update the notification token for the authenticated user
     *
     * @tags Notification
     * @name AppNotificationControllerToken
     * @summary Refresh notification user
     * @request PUT:/utilities/app/notifications/token
     */
    appNotificationControllerToken: (
      data: UtilitiesNotificationTokenDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/utilities/app/notifications/token`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags NotificationServiceConnect
     * @name NotificationServiceConnectControllerHandleCreate
     * @request POST:/utilities/internal/notifications/create
     */
    notificationServiceConnectControllerHandleCreate: (
      data: UtilitiesNotificationCreateServiceConnectPayload,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/utilities/internal/notifications/create`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags NotificationServiceConnect
     * @name NotificationServiceConnectControllerHandleSynchronizeNotificationRecipients
     * @request POST:/utilities/internal/notifications/sync-recipients
     */
    notificationServiceConnectControllerHandleSynchronizeNotificationRecipients:
      (
        data: UtilitiesSynchronizeNotificationRecipientsServiceConnectPayload,
        params: RequestParams = {},
      ) =>
        this.request<
          UtilitiesSynchronizeNotificationRecipientsServiceConnectResponse,
          any
        >({
          path: `/utilities/internal/notifications/sync-recipients`,
          method: "POST",
          body: data,
          type: ContentType.Json,
          format: "json",
          ...params,
        }),

    /**
     * @description Download a document
     *
     * @tags MyDocuments
     * @name DocumentsControllerDownloadDocument
     * @summary Download a document
     * @request GET:/utilities/my-documents/app/download/{token}
     */
    documentsControllerDownloadDocument: (
      token: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/utilities/my-documents/app/download/${token}`,
        method: "GET",
        ...params,
      }),

    /**
     * @description Mark document notes as read
     *
     * @tags MyDocuments
     * @name DocumentsControllerMarkNotesAsRead
     * @summary Mark document notes as read
     * @request PUT:/utilities/my-documents/app/{categoryCode}/documents/{docId}/notes/read
     */
    documentsControllerMarkNotesAsRead: (
      categoryCode: string,
      docId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/utilities/my-documents/app/${categoryCode}/documents/${docId}/notes/read`,
        method: "PUT",
        ...params,
      }),

    /**
     * @description Get documents categories and number of documents
     *
     * @tags MyDocuments
     * @name DocumentsControllerListCategories
     * @summary Get documents categories and number of documents
     * @request GET:/utilities/my-documents/app
     */
    documentsControllerListCategories: (params: RequestParams = {}) =>
      this.request<UtilitiesMyDocumentAppCategory[], any>({
        path: `/utilities/my-documents/app`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Get documents by category
     *
     * @tags MyDocuments
     * @name DocumentsControllerListDocuments
     * @summary Get documents by category
     * @request GET:/utilities/my-documents/app/{categoryCode}/documents
     */
    documentsControllerListDocuments: (
      categoryCode: string,
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesMyDocument[], any>({
        path: `/utilities/my-documents/app/${categoryCode}/documents`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Get details of of the document
     *
     * @tags MyDocuments
     * @name DocumentsControllerGetDocument
     * @summary Get details of the document
     * @request GET:/utilities/my-documents/app/{categoryCode}/documents/{docId}/downloadUrl
     */
    documentsControllerGetDocument: (
      categoryCode: string,
      docId: string,
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesMyDocumentDownload, any>({
        path: `/utilities/my-documents/app/${categoryCode}/documents/${docId}/downloadUrl`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Get documents categories and number of documents
     *
     * @tags MyDocuments
     * @name DocumentsControllerListCategoriesAdmin
     * @summary Get documents categories and number of documents
     * @request GET:/utilities/my-documents
     */
    documentsControllerListCategoriesAdmin: (params: RequestParams = {}) =>
      this.request<UtilitiesMyDocumentCategory[], any>({
        path: `/utilities/my-documents`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Create document category
     *
     * @tags MyDocuments
     * @name DocumentsControllerCreateCategory
     * @summary Create document category
     * @request POST:/utilities/my-documents
     */
    documentsControllerCreateCategory: (params: RequestParams = {}) =>
      this.request<UtilitiesMyDocumentCategory, any>({
        path: `/utilities/my-documents`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * @description Create a warning for a document category
     *
     * @tags MyDocuments
     * @name DocumentsControllerCreateWarning
     * @summary Create a warning for a document category
     * @request POST:/utilities/my-documents/{categoryCode}/warnings
     */
    documentsControllerCreateWarning: (
      categoryCode: string,
      data: UtilitiesCreateMyDocumentCategoryWarningBody,
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesMyDocumentCategory, any>({
        path: `/utilities/my-documents/${categoryCode}/warnings`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a warning for a document category
     *
     * @tags MyDocuments
     * @name DocumentsControllerDeleteWarning
     * @summary Delete a warning for a document category
     * @request DELETE:/utilities/my-documents/{categoryCode}/warnings/{id}
     */
    documentsControllerDeleteWarning: (
      categoryCode: string,
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesMyDocumentCategory, any>({
        path: `/utilities/my-documents/${categoryCode}/warnings/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * @description Update a warning for a document category
     *
     * @tags MyDocuments
     * @name DocumentsControllerUpdateWarning
     * @summary Update a warning for a document category
     * @request PUT:/utilities/my-documents/{categoryCode}/warnings/{id}
     */
    documentsControllerUpdateWarning: (
      categoryCode: string,
      id: string,
      data: UtilitiesUpdateMyDocumentCategoryWarningBody,
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesMyDocumentCategory, any>({
        path: `/utilities/my-documents/${categoryCode}/warnings/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Create a note for a document category
     *
     * @tags MyDocuments
     * @name DocumentsControllerCreateNote
     * @summary Create a note for a document category
     * @request POST:/utilities/my-documents/{categoryCode}/notes
     */
    documentsControllerCreateNote: (
      categoryCode: string,
      data: UtilitiesCreateMyDocumentCategoryNoteBody,
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesMyDocumentCategory, any>({
        path: `/utilities/my-documents/${categoryCode}/notes`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete a note for a document category
     *
     * @tags MyDocuments
     * @name DocumentsControllerDeleteNote
     * @summary Delete a note for a document category
     * @request DELETE:/utilities/my-documents/{categoryCode}/notes/{id}
     */
    documentsControllerDeleteNote: (
      categoryCode: string,
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesMyDocumentCategory, any>({
        path: `/utilities/my-documents/${categoryCode}/notes/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * @description Update a note for a document category
     *
     * @tags MyDocuments
     * @name DocumentsControllerUpdateNote
     * @summary Update a note for a document category
     * @request PUT:/utilities/my-documents/{categoryCode}/notes/{id}
     */
    documentsControllerUpdateNote: (
      categoryCode: string,
      id: string,
      data: UtilitiesUpdateMyDocumentCategoryNoteBody,
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesMyDocumentCategory, any>({
        path: `/utilities/my-documents/${categoryCode}/notes/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update document category
     *
     * @tags MyDocuments
     * @name DocumentsControllerUpdateCategory
     * @summary Update document category
     * @request PUT:/utilities/my-documents/{categoryCode}
     */
    documentsControllerUpdateCategory: (
      categoryCode: string,
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesMyDocumentCategory, any>({
        path: `/utilities/my-documents/${categoryCode}`,
        method: "PUT",
        format: "json",
        ...params,
      }),

    /**
     * @description Delete document category
     *
     * @tags MyDocuments
     * @name DocumentsControllerDeleteCategory
     * @summary Delete document category
     * @request DELETE:/utilities/my-documents/{categoryCode}
     */
    documentsControllerDeleteCategory: (
      categoryCode: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/utilities/my-documents/${categoryCode}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Get hr workflow document token
     *
     * @tags HrDocumentation
     * @name HrDocumentationControllerGetInvitationToken
     * @summary Get hr document workflow token
     * @request GET:/utilities/hr-documentation
     */
    hrDocumentationControllerGetInvitationToken: (params: RequestParams = {}) =>
      this.request<UtilitiesHrDocumentationToken, any>({
        path: `/utilities/hr-documentation`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a list of all chats for admin users
     *
     * @tags Backoffice Chat
     * @name BackofficeChatControllerGetChats
     * @summary Get all chats
     * @request GET:/utilities/backoffice-chats
     * @secure
     */
    backofficeChatControllerGetChats: (
      query?: {
        /**
         * Page number (default is 1)
         * @min 1
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Page size (default is 10)
         * @min 1
         * @default 10
         * @example 10
         */
        size?: number;
        /**
         * Whether to get the total count
         * @default false
         * @example false
         */
        getTotalCount?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesBackofficeChatListResponse, any>({
        path: `/utilities/backoffice-chats`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Creates a new chat
     *
     * @tags Backoffice Chat
     * @name BackofficeChatControllerCreateChat
     * @summary Create a new chat
     * @request POST:/utilities/backoffice-chats
     * @secure
     */
    backofficeChatControllerCreateChat: (
      data: UtilitiesCreateChatBody,
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesCreateChatResponse, any>({
        path: `/utilities/backoffice-chats`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Generates a pre-signed upload URL for uploading a file related to an activity of an existing onboarding.
     *
     * @tags Backoffice Chat
     * @name BackofficeChatControllerGenerateActivityUploadFileUrl
     * @summary Generate upload file URL for an activity of an existing onboarding.
     * @request GET:/utilities/backoffice-chats/upload-file-url
     * @secure
     */
    backofficeChatControllerGenerateActivityUploadFileUrl: (
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesPresignedStorageResource, any>({
        path: `/utilities/backoffice-chats/upload-file-url`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a chat by its ID
     *
     * @tags Backoffice Chat
     * @name BackofficeChatControllerGetChat
     * @summary Get a chat
     * @request GET:/utilities/backoffice-chats/{id}
     * @secure
     */
    backofficeChatControllerGetChat: (id: string, params: RequestParams = {}) =>
      this.request<UtilitiesBackofficeChatDetailResponse, any>({
        path: `/utilities/backoffice-chats/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Updates a chat, only draft chats can be updated
     *
     * @tags Backoffice Chat
     * @name BackofficeChatControllerUpdateDraftChat
     * @summary Update a chat
     * @request PUT:/utilities/backoffice-chats/{id}
     * @secure
     */
    backofficeChatControllerUpdateDraftChat: (
      id: string,
      data: UtilitiesUpdateDraftChatBody,
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesUpdateDraftChatResponse, any>({
        path: `/utilities/backoffice-chats/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Deletes a chat and all its messages
     *
     * @tags Backoffice Chat
     * @name BackofficeChatControllerDeleteChat
     * @summary Delete a chat
     * @request DELETE:/utilities/backoffice-chats/{id}
     * @secure
     */
    backofficeChatControllerDeleteChat: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/utilities/backoffice-chats/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Publishes a chat, only draft chats can be published
     *
     * @tags Backoffice Chat
     * @name BackofficeChatControllerPublishDraftChat
     * @summary Publish a chat
     * @request POST:/utilities/backoffice-chats/{id}/publish
     * @secure
     */
    backofficeChatControllerPublishDraftChat: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/utilities/backoffice-chats/${id}/publish`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Blocks a chat, only published chats can be blocked
     *
     * @tags Backoffice Chat
     * @name BackofficeChatControllerBlockPublishedChat
     * @summary Block a chat
     * @request POST:/utilities/backoffice-chats/{id}/block
     * @secure
     */
    backofficeChatControllerBlockPublishedChat: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/utilities/backoffice-chats/${id}/block`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Sends a message to a chat, only published chats can receive messages
     *
     * @tags Backoffice Chat
     * @name BackofficeChatControllerSendMessageToBackofficeChat
     * @summary Send a message to a chat
     * @request POST:/utilities/backoffice-chats/{id}/messages
     * @secure
     */
    backofficeChatControllerSendMessageToBackofficeChat: (
      id: string,
      data: UtilitiesSendMessageToBackofficeChatBody,
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesSendMessageToBackofficeChatResponse, any>({
        path: `/utilities/backoffice-chats/${id}/messages`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns messages for a chat for a specific user, only non-draft chats can be accessed
     *
     * @tags Backoffice Chat
     * @name BackofficeChatControllerGetMessagesForBackofficeChat
     * @summary Get messages for a chat for a specific user
     * @request GET:/utilities/backoffice-chats/{id}/messages
     * @secure
     */
    backofficeChatControllerGetMessagesForBackofficeChat: (
      id: string,
      query: {
        /**
         * Page number (default is 1)
         * @min 1
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Page size (default is 10)
         * @min 1
         * @default 10
         * @example 10
         */
        size?: number;
        /**
         * Whether to get the total count
         * @default false
         * @example false
         */
        getTotalCount?: boolean;
        /**
         * The mandatory ID of the user to get messages for
         * @example "60c72b2f9b1e8d001c8e4f3a"
         */
        userId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesBackofficeChatDetailMessageListResponse, any>({
        path: `/utilities/backoffice-chats/${id}/messages`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Sends a message from the authenticated user to their HR manager
     *
     * @tags Chat
     * @name ChatControllerSendMessageToHrManager
     * @summary Send a message to the HR manager
     * @request POST:/utilities/chats/hr-manager
     * @secure
     */
    chatControllerSendMessageToHrManager: (
      data: UtilitiesSendMessageToHrManagerBody,
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesSendMessageToChatResponse, any>({
        path: `/utilities/chats/hr-manager`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a list of all PUBLISHED and BLOCKED chats for the authenticated user
     *
     * @tags Chat
     * @name ChatControllerGetAvailableChats
     * @summary Get all chats
     * @request GET:/utilities/chats
     * @secure
     */
    chatControllerGetAvailableChats: (
      query?: {
        /**
         * Page number (default is 1)
         * @min 1
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Page size (default is 10)
         * @min 1
         * @default 10
         * @example 10
         */
        size?: number;
        /**
         * Whether to get the total count
         * @default false
         * @example false
         */
        getTotalCount?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesChatListResponse, any>({
        path: `/utilities/chats`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a pre-signed upload URL and the file key to attach to a message
     *
     * @tags Chat
     * @name ChatControllerGenerateUploadFileUrl
     * @summary Generate a presigned URL to upload a chat attachment
     * @request GET:/utilities/chats/upload-file-url
     * @secure
     */
    chatControllerGenerateUploadFileUrl: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/utilities/chats/upload-file-url`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Chat
     * @name ChatControllerGetChatDetail
     * @summary Get the detail of a chat
     * @request GET:/utilities/chats/{id}
     * @secure
     */
    chatControllerGetChatDetail: (id: string, params: RequestParams = {}) =>
      this.request<UtilitiesChatDetailResponse, any>({
        path: `/utilities/chats/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Action that marks the chat as read for the authenticated user by storing the last read timestamp
     *
     * @tags Chat
     * @name ChatControllerMarkChatAsRead
     * @summary Mark a chat as read
     * @request POST:/utilities/chats/{id}/read
     * @secure
     */
    chatControllerMarkChatAsRead: (id: string, params: RequestParams = {}) =>
      this.request<UtilitiesChatReadStatusResponse, any>({
        path: `/utilities/chats/${id}/read`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Sends a message to a chat, only published chats can receive messages
     *
     * @tags Chat
     * @name ChatControllerSendMessageToBackofficeChat
     * @summary Send a message to a chat
     * @request POST:/utilities/chats/{id}/messages
     * @secure
     */
    chatControllerSendMessageToBackofficeChat: (
      id: string,
      data: UtilitiesSendMessageToChatBody,
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesSendMessageToChatResponse, any>({
        path: `/utilities/chats/${id}/messages`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns the user's own messages for a chat, only non-draft chats can be accessed
     *
     * @tags Chat
     * @name ChatControllerGetMessagesForChat
     * @summary Get my own messages for a chat
     * @request GET:/utilities/chats/{id}/messages
     * @secure
     */
    chatControllerGetMessagesForChat: (
      id: string,
      query?: {
        /**
         * Page number (default is 1)
         * @min 1
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Page size (default is 10)
         * @min 1
         * @default 10
         * @example 10
         */
        size?: number;
        /**
         * Whether to get the total count
         * @default false
         * @example false
         */
        getTotalCount?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesChatDetailMessageListResponse, any>({
        path: `/utilities/chats/${id}/messages`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns the app config
     *
     * @tags App Config
     * @name AppConfigControllerFindById
     * @summary Get app config
     * @request GET:/utilities/app-config
     */
    appConfigControllerFindById: (params: RequestParams = {}) =>
      this.request<UtilitiesAppConfigResponse, void>({
        path: `/utilities/app-config`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a paginated list of resources matching the search criteria.
     *
     * @tags Global search
     * @name GlobalSearchControllerFindAll
     * @summary Search resources globally
     * @request GET:/utilities/global-search
     */
    globalSearchControllerFindAll: (
      query: {
        /**
         * Page number (default is 1)
         * @min 1
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Page size (default is 10)
         * @min 1
         * @default 10
         * @example 10
         */
        size?: number;
        /**
         * Whether to get the total count
         * @default false
         * @example false
         */
        getTotalCount?: boolean;
        /** Search term to filter resources by title */
        search: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesPaginatedGlobalSearchResponse, any>({
        path: `/utilities/global-search`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags JobPosting
     * @name AdminJobPostingControllerSync
     * @request POST:/utilities/admin/job-posting/sync
     */
    adminJobPostingControllerSync: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/utilities/admin/job-posting/sync`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags JobPosting
     * @name AdminJobPostingControllerFindAll
     * @request GET:/utilities/admin/job-posting
     */
    adminJobPostingControllerFindAll: (
      query?: {
        /**
         * Page number (default is 1)
         * @min 1
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Page size (default is 10)
         * @min 1
         * @default 10
         * @example 10
         */
        size?: number;
        /**
         * Whether to get the total count
         * @default false
         * @example false
         */
        getTotalCount?: boolean;
        /**
         * Field to sort by
         * @example "name"
         */
        sortBy?: string;
        /**
         * Order of sorting (asc or desc)
         * @example "asc"
         */
        orderBy?: "asc" | "desc";
        /** Filter job postings by job title. Partial and case-insensitive matching is supported. */
        search?: string;
        /** Filter job postings by their internal status. */
        status?: "ACTIVE" | "NOT_ACTIVE";
      },
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesPaginatedAdminJobPostResponse, any>({
        path: `/utilities/admin/job-posting`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags JobPosting
     * @name AdminJobPostingControllerFindOne
     * @request GET:/utilities/admin/job-posting/{id}
     */
    adminJobPostingControllerFindOne: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesAdminJobPostResponse, any>({
        path: `/utilities/admin/job-posting/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags JobPosting
     * @name AdminJobPostingControllerUpdate
     * @request PUT:/utilities/admin/job-posting/{id}
     */
    adminJobPostingControllerUpdate: (
      id: UtilitiesObjectId,
      data: UtilitiesUpdateAdminJobPostBody,
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesAdminJobPostResponse, any>({
        path: `/utilities/admin/job-posting/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags JobPosting
     * @name JobPostingControllerFindAll
     * @request GET:/utilities/job-posting
     */
    jobPostingControllerFindAll: (
      query?: {
        /**
         * Page number (default is 1)
         * @min 1
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * Page size (default is 10)
         * @min 1
         * @default 10
         * @example 10
         */
        size?: number;
        /**
         * Whether to get the total count
         * @default false
         * @example false
         */
        getTotalCount?: boolean;
        /**
         * Field to sort by
         * @example "name"
         */
        sortBy?: string;
        /**
         * Order of sorting (asc or desc)
         * @example "asc"
         */
        orderBy?: "asc" | "desc";
        /** Filter job postings by job title. Partial and case-insensitive matching is supported. */
        search?: string;
        /** Filter job postings by their internal status. */
        status?: "ACTIVE" | "NOT_ACTIVE";
      },
      params: RequestParams = {},
    ) =>
      this.request<UtilitiesPaginatedJobPostResponse, any>({
        path: `/utilities/job-posting`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
}
